import ClientAllocation from './ClientAllocation';

export default ClientAllocation;
